import React, {MouseEvent} from "react";
import {Link, useNavigate} from "react-router-dom";
import {DbUserConfigModel} from "../../../model/db/dbUserConfigModel";
import useMgLatestTime from "../../../hooks/use-mgLatestTime-view";
import dayjs from "dayjs";

export interface DashboardCardProps {
  title: string;
  children: React.ReactNode;
  isConfigMode?: boolean;
  moreButtonVisible?: boolean;
  moreButtonUrl?: string;
  dashboardConfig? :DbUserConfigModel;
  deleteButtonOnClick?: (data: DbUserConfigModel) => void;
  mgMdmsType?: mgMdmsType;
}
type mgMdmsType = 'K' | 'M' | 'KM';
type TimeFormat = 'YMD' | 'YM' | 'YMDH';

export default function DashboardCard(props: Readonly<DashboardCardProps>) {
  const navigate = useNavigate();
  const {
    title,
    children,
    isConfigMode = props.isConfigMode ?? false,
    moreButtonVisible = props.moreButtonVisible ?? false,
    moreButtonUrl,
    dashboardConfig,
    deleteButtonOnClick,
    mgMdmsType,
  } = props;
  const displayTimeFromHook = useMgLatestTime(mgMdmsType ?? 'KM');
  const displayTime = mgMdmsType ? displayTimeFromHook : dayjs();

  function handleClickMoreButton(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();

    if (moreButtonUrl) {
      navigate(moreButtonUrl);
    }
  }

  function handleClickDeleteButton(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();

    if (deleteButtonOnClick && dashboardConfig) {
      deleteButtonOnClick(dashboardConfig);
    }
  }

  function convertTimeByFormat(format: TimeFormat, time: dayjs.Dayjs) {
    switch (format) {
      case 'YMDH': return time.format('YYYY.MM.DD HH:mm');
      case 'YMD' : return time.format('YYYY.MM.DD');
      case 'YM'  :
      default    : return time.format('YYYY.MM');
    }
  }

  return (
    <>
      {isConfigMode && dashboardConfig ? (
        <div className="col-md-12" style={{height: '100%'}}>
          <div className="cont">
            <h2 className="titT2 bl"><span>{title}</span></h2>
            <div className="n-overlay config-mode show" style={{opacity: 0}} />
            {children}
          </div>
        </div>
      ) : (
        <div className="col-md-6">
          <div className="cont">
            <h2 className={`titT2 bl ${mgMdmsType ? 'withBadge' : '' } `}><span>{title}</span>
              {mgMdmsType &&
                <em className="standard-badge">
                  <i className="las la-clock" aria-hidden={true} />
                  {convertTimeByFormat('YMDH', displayTime)} 기준
                </em>
              }
            </h2>
            {children}
            {moreButtonVisible && moreButtonUrl && (
              <Link className="more-btn" to="#" onClick={handleClickMoreButton}>
                <i className="xi-plus" aria-hidden="true" />
                <span className="hid">더보기</span>
              </Link>
            )}
          </div>
        </div>
      )}
    </>
  );
}